<template>
    <el-popover
        :placement="placement||'bottom'"
        width="80"
        :value="visible"
    >
        <p class="editPop_action" @click="visible=false;handleEdit()">修改名称</p>
        <p class="editPop_action" style="margin-bottom:0;" @click="visible=false;handleDel()">删除</p>
        <span @click="visible=true" slot="reference"><slot></slot></span>
    </el-popover>
</template>

<script>
    export default {
        props: ['handleEdit', 'handleDel'],
        data () {
            return {
                visible: false,
            };
        }
    };
</script>

<style lang="less">
    .editPop_action {
        margin-top: 0;
        text-align: center;
        cursor: pointer;
        &:hover {
            color: rgba(96, 98, 102, 0.67);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SetPosition/EditPopover.vue